import React from 'react'
import {
    OverContainer,
    OverContainerSection,
    ContentInformation,
    NameTypography,
    PositionTypography,
    InformationPerson,
    VideoSection,
    AboutSection,
    AboutTitleTypography,
    AboutContentTypography,
    SocialCard,
    ImageSection,
    ContentImage,
} from './styles'
import { FooterSocial } from 'src/constants'
import { MapSocial } from './mapSocial'
import BackButton from 'src/components/common/BackButton/BackButton'
import { ProfileSectionProps } from 'pages/DetailedProfile/ProfileSection/type'
import { i18n, useTranslations } from 'src/provider/LocaleProvider'

export function ProfileSection(props: ProfileSectionProps) {
    const t = useTranslations()
    const { person } = props
    return (
        <OverContainerSection>
            <OverContainer
                paddingTop={[
                    'xspacesFull',
                    'xspacesFull',
                    'xspacesFull',
                    'navigation',
                ]}
                marginBottom={[0, 0, 'xxxmedium', 'titlle']}
                width={1}
            >
                <BackButton />
            </OverContainer>
            <InformationPerson>
                {person.video ? (
                    <VideoSection
                        playsInline
                        loop
                        muted={true}
                        autoPlay={true}
                        src={person.video}
                    />
                ) : (
                    <ContentImage>
                        <ImageSection src={person.image} alt={person.name} />
                    </ContentImage>
                )}
                <AboutSection marginTop={['xxmedium', 'xxmedium', 'large', 0]}>
                    <ContentInformation>
                        <NameTypography
                            variant={'h1'}
                            fontSize={[
                                'xlarge',
                                'xlarge',
                                'titlle',
                                'titleInitla',
                            ]}
                            fontWeight={900}
                        >
                            {person.name}
                        </NameTypography>

                        <PositionTypography
                            variant={'h2'}
                            fontSize={[
                                'medium',
                                'medium',
                                'xlarge',
                                'xxxmedium',
                            ]}
                            fontWeight={400}
                        >
                            {i18n.t(person.WorkField)}
                        </PositionTypography>
                    </ContentInformation>
                    <ContentInformation>
                        <AboutTitleTypography
                            variant={'h2'}
                            fontSize={[
                                'medium',
                                'medium',
                                'xxmedium',
                                'xmedium',
                            ]}
                            fontWeight={600}
                        >
                            {t('footer.aboutUs')}:
                        </AboutTitleTypography>
                        <AboutContentTypography
                            variant={'h2'}
                            fontSize={['xsmall', 'xsmall', 'medium', 'xxsmall']}
                            fontWeight={400}
                        >
                            {person.textCity}
                        </AboutContentTypography>
                        <SocialCard marginTop={'xxsmall'}>
                            {FooterSocial.map((social) => {
                                return <MapSocial key={social.id} {...social} />
                            })}
                        </SocialCard>
                    </ContentInformation>
                </AboutSection>
            </InformationPerson>
        </OverContainerSection>
    )
}
